import { UserProfileModel } from '../../models/user-profile.model';
import { ProfileCheckModel } from '../../models/profile-check.model';
import { EnvironmentSettingsModel } from '../../models/environment-settings.model';
import { SignUpModel, SignUpResponseModel } from '../../models/sign-up.model';
import { GoogleLoginModel } from '../../models/google-login.model';
import { FacebookLoginModel } from '../../models/facebook-login.model';
import { HttpErrorResponse } from '@angular/common/http';
import { LocaleModel } from 'src/app/shared/models/locale.model';
import { BiodigitalLoginModel } from '../../models/biodigital-login.model';
import { UserAppModel } from 'src/app/auth/models/user-app.model';
import { UserMessageEnum, UserMessageModel } from '../../models/user-message-model';
import { LoginResponseModel } from '../../models/login-base-model';
import { VerifyEmailCodeResponseModel } from '../../models/verification/verify-email-code-response.model';
import { VerifyEmailResponseModel } from '../../models/verification/verify-email-response.model';
import { CalloutContentModel } from 'src/app/shared/components/user-access/models/callout-content.model';
import { UserRestrictionEnum } from 'src/app/shared/components/user-access/models/user-restriction.enum';
import { CalloutDisplayEnum } from 'src/app/shared/components/user-access/models/callout-display.enum';
import { ContentType } from 'src/app/story/models/content-type.enum';
import { ContentViewsModel } from '../../models/content-views.model';

export class IsLoggedIn {
  static readonly type = '[Auth] Is Logged In';
  constructor() {}
}

export class IsLoggedInSuccess {
  static readonly type = '[Auth] Is Logged In Success';
  constructor() {}
}

export class IsLoggedInFailure {
  static readonly type = '[Auth] Is Logged In Failure';
  constructor() {}
}

export class LoginWithBiodigital {
  static readonly type = '[Auth] Login With Biodigital';
  constructor(public login: BiodigitalLoginModel) {}
}

export class FacebookAuthOnline {
  static readonly type = '[Auth] Facebook Auth Service Online';
  constructor(public online: boolean) {}
}

export class InitializeSocialAuth {
  static readonly type = '[Auth] Load Google and Facebook Auth';
}

export class GoogleAuthStatus {
  static readonly type = '[Auth] Google Auth Service Online';
  constructor(public online: 'waiting' | 'loading' | 'ready' | 'error') {}
}

export class LoginWithGoogle {
  static readonly type = '[Auth] Login With Google';
  constructor(public login: GoogleLoginModel) {}
}

// Deprecated
export class LoginWithFacebook {
  static readonly type = '[Auth] Login With Facebook';
  constructor(public login: FacebookLoginModel) {}
}

export class LoginSuccess {
  static readonly type = '[Auth] Login Success';
  constructor(public loginType: string, public response: LoginResponseModel) {}
}

export class LoginFailure {
  static readonly type = '[Auth] Login Failure';
  constructor(
    public loginType: string,
    public error: HttpErrorResponse,
    public login: BiodigitalLoginModel | GoogleLoginModel | FacebookLoginModel,
  ) {}
}

export class Logout {
  static readonly type = '[Auth] Logout';
  constructor() {}
}

export class LogoutSuccess {
  static readonly type = '[Auth] Logout Success';
  constructor() {}
}

export class LogoutFailure {
  static readonly type = '[Auth] Logout Failure';
  constructor() {}
}

export class GetEnvironmentSettings {
  static readonly type = '[Auth] Get Environment Settings';
  constructor() {}
}

export class GetEnvironmentSettingsSuccess {
  static readonly type = '[Auth] Get Environment Settings Success';
  constructor(public environmentSettings: EnvironmentSettingsModel) {}
}

export class GetEnvironmentSettingsFailure {
  static readonly type = '[Auth] Get Environment Settings Failure';
  constructor(public error: Error) {}
}

export class GetUserProfile {
  static readonly type = '[Auth] Get User Profile';
  constructor(public hardCheck = false) {}
}

export class GetUserProfileSuccess {
  static readonly type = '[Auth] Get User Profile Success';
  constructor(public userProfile: UserProfileModel) {}
}

export class GetUserProfileFailure {
  static readonly type = '[Auth] Get User Profile Failure';
  constructor(public error: Error) {}
}

export class UpdateUserProfile {
  static readonly type = '[Auth] Update User Profile';
  constructor(public userProfile: Partial<UserProfileModel>) {}
}

export class UpdateUserProfileSuccess {
  static readonly type = '[Auth] Update User Profile Success';
  constructor(public userProfile: Partial<UserProfileModel>) {}
}

export class UpdateUserProfileFailure {
  static readonly type = '[Auth] Update User Profile Failure';
  constructor(public error: Error) {}
}

export class DeleteUserProfile {
  static readonly type = '[Auth] Delete User Profile';
  constructor() {}
}

export class DeleteUserProfileSuccess {
  static readonly type = '[Auth] Delete User Profile Success';
  constructor(public userEmail: string) {}
}

export class DeleteUserProfileFailure {
  static readonly type = '[Auth] Delete User Profile Failure';
  constructor(public error: Error) {}
}

export class CheckProfile {
  static readonly type = '[Auth] Check Profile';
  constructor(public email: string) {}
}

export class CheckProfileSuccess {
  static readonly type = '[Auth] Check Profile Success';
  constructor(public profile: ProfileCheckModel) {}
}

export class CheckProfileFailure {
  static readonly type = '[Auth] Check Profile Failure';
  constructor(public error: Error) {}
}

export class GetUserRoles {
  static readonly type = '[Auth] Get User Roles';
  constructor() {}
}

export class ResetPassword {
  static readonly type = '[Auth] Reset Password';
  constructor(public email: string) {}
}

export class ResetPasswordSuccess {
  static readonly type = '[Auth] Reset Password Success';
  constructor(public email: string) {}
}

export class ResetPasswordFailure {
  static readonly type = '[Auth] Reset Password Failure';
  constructor(public error: Error) {}
}

export class UpdatePassword {
  static readonly type = '[Auth] Update Password';
  constructor(
    public currentPassword: string,
    public newPassword: string,
    public confirmNewPassword: string,
  ) {}
}

export class UpdatePasswordSuccess {
  static readonly type = '[Auth] Update Password Success';
  constructor() {}
}

export class UpdatePasswordFailure {
  static readonly type = '[Auth] Update Password Failure';
  constructor(public error: Error) {}
}

export class CheckSession {
  static readonly type = '[Auth] Check Session';
  constructor() {}
}

export class SignUp {
  static readonly type = '[Auth] Sign Up';
  constructor(public value: SignUpModel) {}
}

export class SignUpSuccess {
  static readonly type = '[Auth] Sign Up Success';
  constructor(public response: SignUpResponseModel) {}
}

export class SignUpFailure {
  static readonly type = '[Auth] Sign Up Failure';
  constructor(public error: HttpErrorResponse) {}
}

export class SetUserLocale {
  static readonly type = '[Auth] Set User Locale';
  constructor(public locale: LocaleModel) {}
}

export class SetUserLocaleSuccess {
  static readonly type = '[Auth] Set User Locale Success';
  constructor(public locale: LocaleModel) {}
}

export class CheckLocale {
  static readonly type = '[Auth] Check Locale';
  constructor() {}
}

export class GetUserApps {
  static readonly type = '[Auth] Get User Apps';
  constructor() {}
}

export class SetUserApps {
  static readonly type = '[Auth] Set User Apps';
  constructor(public apps: UserAppModel[]) {}
}

export class CheckSelectedUserApp {
  static readonly type = '[Auth] Check Selected App';
  constructor() {}
}

export class SetSelectedUserApp {
  static readonly type = '[Auth] Set Selected User App';
  constructor(public appId: number) {}
}

export class SendUserMessage {
  static readonly type = '[Auth] Send User Message';
  constructor(public message: { type: string; id: string }) {}
}

export class SendUserMessageSuccess {
  static readonly type = '[Auth] Send User Message Success';
  constructor(public message: { type: string; id: string }) {}
}

export class SendUserMessageFail {
  static readonly type = '[Auth] Send User Message Fail';
  constructor(public err: Error) {}
}

export class GetUserMessage {
  static readonly type = '[Auth] Get User Message';
  constructor(public type: UserMessageEnum, public mode: string) {}
}

export class GetUserMessageSuccess {
  static readonly type = '[Auth] Get User Message Success';
  constructor(public message: UserMessageModel) {}
}

export class GetUserMessageFail {
  static readonly type = '[Auth] Get User Message Fail';
  constructor(public type: UserMessageEnum) {}
}

export class SetUserMessageViewed {
  static readonly type = '[Auth] Set Message Viewed';
  constructor(public messageSeenId: string) {}
}

export class SetUserMessageViewedSuccess {
  static readonly type = '[Auth] Set Message Viewed Success';
  constructor() {}
}

export class SetUserMessageViewedFail {
  static readonly type = '[Auth] Set Message Viewed Fail';
  constructor() {}
}

export class VerifyFail {
  static readonly type = '[Auth] Verify Fail';
  constructor() {}
}

export class ResetAuth {
  static readonly type = '[Auth] Reset';
  constructor() {}
}

export class DeleteStoredData {
  static readonly type = '[Auth] Delete Stored Data';
  constructor() {}
}

export class RequestVerificationCode {
  static readonly type = '[Auth] Request Verification Code';
  constructor(public email: string, public token: string) {}
}

export class RequestVerificationCodeSuccess {
  static readonly type = '[Auth] Request Verification Code Success';
  constructor(public response: VerifyEmailCodeResponseModel) {}
}

export class RequestVerificationCodeFail {
  static readonly type = '[Auth] Request Verification Code Fail';
  constructor(public error: HttpErrorResponse) {}
}

export class VerifyProfile {
  static readonly type = '[Auth] Verify Profile';
  constructor(public email: string, public token: string, public code: string) {}
}

export class VerifyProfileSuccess {
  static readonly type = '[Auth] Verify Profile Success';
  constructor(public response: VerifyEmailResponseModel) {}
}

export class VerifyProfileFail {
  static readonly type = '[Auth] Verify Profile Fail';
  constructor(public error: HttpErrorResponse) {}
}

export class NotifyUserRestriction {
  static readonly type = '[Auth] Notify User Restriction';
  constructor(
    public type: UserRestrictionEnum,
    public display: CalloutDisplayEnum,
    public data?: CalloutContentModel,
  ) {}
}

export class ClearUserRestriction {
  static readonly type = '[Auth] Clear User Restriction';
  constructor(public displays: CalloutDisplayEnum[]) {}
}

export class SetContentViewed {
  static readonly type = '[Auth] Set Content Viewed';
  constructor(public contentId: string, public contentType: ContentType) {}
}

export class SetContentViewedSuccess {
  static readonly type = '[Auth] Set Content Viewed Success';
  constructor() {}
}

export class CheckContentViews {
  static readonly type = '[Auth] Check Content Viewed';
  constructor() {}
}

export class CheckContentViewsSuccess {
  static readonly type = '[Auth] Check Content Viewed Success';
  constructor(public contentViews: ContentViewsModel) {}
}

export class SetDeveloperReferral {
  static readonly type = '[Auth] Set Developer Referral';
  constructor(public isDeveloperReferral: boolean) {}
}
